import { useQuery } from '@apollo/client';

import type { UseFeatureSwitchesQuery } from './feature-switches-query.gql-types';
import { UseFeatureSwitchesDocument } from './feature-switches-query.gql-types';

export type { UseFeatureSwitchesQuery };

/**
 * `useFeatureSwitch` queries the feature-switch data from the Apollo cache.
 *
 * `const fs = useFeatureSwitches();`
 * As default it will return the whole feature-switch array.
 *
 * `const fs = useFeatureSwitches(['flag-1', 'flag-2']);`
 * With the option to pass a an array with flags it will check if all flags are present and will return a boolean.
 *
 * @param {Array} flags
 */
export function useFeatureSwitches(): string[];
export function useFeatureSwitches(flags: string[]): boolean;
export function useFeatureSwitches(flags?: string[]): Array<string> | boolean {
  const { data } = useQuery(UseFeatureSwitchesDocument, {
    fetchPolicy: 'cache-only',
  });

  const featureSwitches = data?.viewer?.featureSwitches || [];

  if (flags !== undefined) {
    return flags.every((flag) => featureSwitches.includes(flag));
  }

  return featureSwitches;
}
